import { NavLink } from "react-router-dom";

// Small floating dev switcher (bottom-left) to hop between the 3 harness
// pages during manual testing. Marked [data-comments-ui] so review-mode's
// sticky-freeze leaves it alone (stays fixed & reachable). Bottom-left keeps
// it clear of the Pinlayr toolbar / review CTA which live bottom-right.
const LINKS = [
  { to: "/demo/landing", label: "Landing" },
  { to: "/demo/article", label: "Article" },
  { to: "/demo/product", label: "Product" },
];

export default function DevNav() {
  return (
    <div
      data-comments-ui
      data-testid="dev-nav"
      className="fixed bottom-4 left-4 z-[9990] flex items-center gap-1 rounded-full border border-slate-200 bg-white/95 p-1 shadow-lg backdrop-blur"
    >
      <span className="px-2 text-[10px] font-semibold uppercase tracking-widest text-slate-400">Dev</span>
      {LINKS.map((l) => (
        <NavLink
          key={l.to}
          to={l.to}
          data-testid={`dev-nav-${l.label.toLowerCase()}`}
          className={({ isActive }) =>
            `rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
              isActive
                ? "bg-indigo-600 text-white"
                : "text-slate-600 hover:bg-slate-100"
            }`
          }
        >
          {l.label}
        </NavLink>
      ))}
    </div>
  );
}
